import { TFactoryListActions } from './factory-list.actions';
import { TFactoryListState, TFactoryListInfoActionType } from './factory-list.models';

export const initialState: TFactoryListState = {
  factoryListingInfo: null,
  factoryUom: null,
};

export function factoryListReducer(state = initialState, action: TFactoryListActions): TFactoryListState {
  switch (action.type) {
    case TFactoryListInfoActionType.GetFactoryList:
      return {
        ...state,
        factoryListingInfo: null,
      };
    case TFactoryListInfoActionType.GetFactoryListSuccess:
      return {
        ...state,
        factoryListingInfo: action.factoryListRes,
      };
    case TFactoryListInfoActionType.GetFactoryUomSuccess:
      return {
        ...state,
        factoryUom: action.factoryUom,
      };
    default:
      return state;
  }
}
